import { render, staticRenderFns } from "./ConsultantDetails.vue?vue&type=template&id=20ded478"
import script from "./ConsultantDetails.vue?vue&type=script&lang=js"
export * from "./ConsultantDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports